export default __webpack_public_path__ + "static/media/CollectingInformation.ba197a6c.svg";